export default `
  query listTeamMembers($projectId: String!, $limit: Int, $nextToken: String) {
    listTeamMembers(projectId: $projectId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        email
        projectId
        lastLogin
        createdAt
        user {
          id
          firstname
          lastname
          email
          company
          job
          picture {
            url
            file {
              key
            }
          }
        }
      }
      nextToken
    }
  }
`
